
import React, { useState, useEffect, useRef } from "react";
import { ChevronRight } from "lucide-react";
import { Create_Api_Formdata } from "../../API_URL";
import { toast } from "react-toastify";

export default function ContactSection() {
    const [FirstName, setFirstName] = useState("");
    const [LastName, setLastName] = useState("");
    const [Email, setEmail] = useState("");
    const [Number, setNumber] = useState("");
    const [Company, setCompany] = useState("");
    const [Enquiry, setEnquiry] = useState("General Enquiry");
    const [Message, setMessage] = useState("");

    const [IsLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState("");

    const CreateContactUs = async (e) => {
        e.preventDefault();

        let newErrors = {};

        if (!FirstName.trim()) {
            newErrors.FirstName = "First name is required";
        }

        if (!LastName.trim()) {
            newErrors.LastName = "Last name is required";
        }

        if (!Email.trim()) {
            newErrors.Email = "Business email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(Email)) {
            newErrors.Email = "Please enter a valid email address";
        }

        if (!Number.trim()) {
            newErrors.Number = "Phone number is required";
        } else if (!/^\d{10}$/.test(Number)) {
            newErrors.Number = "Please enter a valid 10-digit phone number";
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return;

        const formData = new FormData();

        // Required fields
        formData.append("FirstName", `${FirstName.trim()} ${LastName.trim()}`);
        formData.append("Email", Email);
        formData.append("PhoneNumber", Number);
        formData.append("Company", Company.trim() || "Not Provided");

        // Default hidden enquiry fields
        formData.append("Enquiry", "General Enquiry");
        formData.append("EnquiryType", "General Enquiry");

        // Default message
        formData.append("Message", Message.trim() || "General Enquiry");

        try {
            setIsLoading(true);
            setSuccessMessage("");

            // Debug API payload
            console.log("Contact Form Payload:");
            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }

            const response = await Create_Api_Formdata(
                "api/admin/CreateContactus",
                formData
            );

            if (response?.data) {
                setSuccessMessage(
                    "Your message has been received. We’ll get back to you as soon as possible."
                );

                setFirstName("");
                setLastName("");
                setEmail("");
                setNumber("");
                setCompany("");
                setEnquiry("General Enquiry");
                setMessage("");
                setErrors({});

                toast.success("Enquiry submitted successfully!");
            } else {
                toast.error(
                    response?.message || "Failed to upload requirement"
                );
            }

        } catch (error) {
            console.error("Error uploading requirement:", error);
            console.error("Backend Response:", error?.response?.data);

            toast.error(
                error?.response?.data?.message ||
                error?.response?.message ||
                "Failed to upload requirement"
            );

        } finally {
            setIsLoading(false);
        }
    };

    // Input styling
    const inputClass =
        "w-full bg-transparent border-0 border-b border-[#CFD2D6] rounded-none px-4 py-[13px] text-[14px] font-graphik font-[500] text-[#191B1F] placeholder:text-[#191B1F] outline-none focus:outline-none focus:ring-0 focus:border-[#191B1F] transition-colors duration-300";

    return (
        <section className="relative w-full overflow-hidden bg-[#FFFEFC] py-[20px] sm:py-[50px] lg:py-[80px] px-1 lg:px-[80px]">
            {/* Background Dotted Patterns */}

            {/*
            <div
                className="absolute pointer-events-none w-[500px] h-[280px] sm:w-[650px] sm:h-[380px] rounded-[50%] opacity-60 rotate-[15deg] left-[5%] bottom-[-180px]"
                style={{
                    backgroundImage:
                        "radial-gradient(circle, #BFC0BE 2px, transparent 2.5px)",
                    backgroundSize: "14px 14px",
                    maskImage:
                        "radial-gradient(ellipse, black 30%, transparent 72%)",
                    WebkitMaskImage:
                        "radial-gradient(ellipse, black 30%, transparent 72%)",
                }}
            />
            */}

            {/*
            <div
                className="absolute pointer-events-none w-[450px] h-[260px] sm:w-[550px] sm:h-[350px] rounded-[50%] opacity-90 rotate-[-15deg] right-[-150px] bottom-[-100px]"
                style={{
                    backgroundImage:
                        "radial-gradient(circle, #222222 2px, transparent 2.5px)",
                    backgroundSize: "14px 14px",
                    maskImage:
                        "radial-gradient(ellipse, black 30%, transparent 72%)",
                    WebkitMaskImage:
                        "radial-gradient(ellipse, black 30%, transparent 72%)",
                }}
            />
            */}

            <div className="relative z-10 max-w-[1440px] mx-auto px-[20px] sm:px-[35px] lg:px-[80px]">
                {/* <div className="absolute max-w-[676px] left-[94px] h-[355px] lg:bottom-[-110px] bottom-0">
                    <img src="/assets/home/wrap2.svg" alt="" />
                </div> */}
                <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.08fr] gap-10 lg:gap-[65px] items-start">

                    <div className="w-full pt-0 relative">

                        <h2 className="font-sora text-[20px] lg:text-[30px] font-semibold text-[#01386A] leading-[1.2] mb-4">
                            Reach Out to Us
                        </h2>

                        <p className="font-graphik text-[14px] sm:text-[16px] text-[#49577A] font-medium leading-[1.6]">
                            Fill up the form below and we'll be in touch
                        </p>

                        <div className="hidden lg:block opacity-100 rotate-[160deg] pointer-events-none mt-[90px]">
                            <FlowingMeshCanvasAlt />
                        </div>
                    </div>

                    {/* RIGHT FORM */}

                    <div className="w-full bg-[#f2f1ef] max-w-[705px] pt-[20px] lg:pt-[30px]">

                        <form
                            onSubmit={CreateContactUs}
                            className=""
                        >
                            <div className="flex flex-col gap-[32px] px-[20px] xl:px-[30px] ">
                                {/* FIRST NAME / LAST NAME */}

                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-[15px] gap-y-[25px]">

                                    <div className="relative">
                                        <input
                                            type="text"
                                            placeholder="First Name*"
                                            value={FirstName}
                                            onChange={(e) => setFirstName(e.target.value)}
                                            className={inputClass}
                                        />

                                        {errors?.FirstName && (
                                            <span className="absolute -bottom-5 left-4 text-red-500 text-[11px]">
                                                {errors.FirstName}
                                            </span>
                                        )}
                                    </div>

                                    <div className="relative">
                                        <input
                                            type="text"
                                            placeholder="Last Name*"
                                            value={LastName}
                                            onChange={(e) => setLastName(e.target.value)}
                                            className={inputClass}
                                        />

                                        {errors?.LastName && (
                                            <span className="absolute -bottom-5 left-4 text-red-500 text-[11px]">
                                                {errors.LastName}
                                            </span>
                                        )}
                                    </div>

                                </div>

                                {/* EMAIL / PHONE */}

                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-[15px] gap-y-[25px]">

                                    <div className="relative">
                                        <input
                                            type="email"
                                            placeholder="Business Email*"
                                            value={Email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            className={inputClass}
                                        />

                                        {errors?.Email && (
                                            <span className="absolute -bottom-5 left-4 text-red-500 text-[11px]">
                                                {errors.Email}
                                            </span>
                                        )}
                                    </div>

                                    <div className="relative">
                                        <input
                                            type="tel"
                                            placeholder="Phone Number*"
                                            value={Number}
                                            onChange={(e) =>
                                                setNumber(
                                                    e.target.value.replace(/\D/g, "").slice(0, 10)
                                                )
                                            }
                                            className={inputClass}
                                        />

                                        {errors?.Number && (
                                            <span className="absolute -bottom-5 left-4 text-red-500 text-[11px]">
                                                {errors.Number}
                                            </span>
                                        )}
                                    </div>

                                </div>

                                {/* MESSAGE */}

                                <div>
                                    <label className="block font-graphik font-[500] text-[14px] text-[#191B1F] mb-3 px-4">
                                        What can we help you with?
                                    </label>

                                    <textarea
                                        rows={3}
                                        value={Message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        className="w-full bg-transparent border-0 border-b border-[#CFD2D6] rounded-none px-4 py-3 text-[14px] font-graphik text-[#191B1F] outline-none focus:outline-none focus:ring-0 focus:border-[#191B1F] resize-y transition-colors duration-300"
                                    />
                                </div>

                                {/* SUCCESS MESSAGE */}

                                {successMessage && (
                                    <div className="p-3 bg-green-50 border border-green-300 text-green-700 text-[13px] font-graphik">
                                        {successMessage}
                                    </div>
                                )}
                            </div>

                            {/* SUBMIT BUTTON */}

                            <div className="lg:pt-[24px] w-full pt-[14px]">

                                <button
                                    type="submit"
                                    disabled={IsLoading}
                                    className="group inline-flex items-center justify-start gap-2 bg-[#002F8D] text-white px-[25px] py-[15px] min-w-[180px] font-graphik text-[14px] w-full font-[500] hover:bg-[#ED6800] hover:text-[#FFFFFF] transition-all duration-300 disabled:opacity-60 disabled:cursor-not-allowed"
                                >
                                    <span>
                                        {IsLoading ? "Please Wait..." : "Get In Touch"}
                                    </span>

                                    <ChevronRight
                                        size={16}
                                        className="group-hover:translate-x-1 transition-transform duration-300"
                                    />
                                </button>

                            </div>

                        </form>

                    </div>

                </div>

            </div>

        </section>
    );
}


/* =========================================
   ANIMATED FLOWING MESH LINES COMPONENT
========================================= */

const FlowingMeshCanvasAlt = () => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext("2d");
        if (!ctx) return;

        let animationFrameId;
        let time = 0;

        const resizeCanvas = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };

        window.addEventListener("resize", resizeCanvas);
        resizeCanvas();

        const draw = () => {
            const { width, height } = canvas;

            ctx.clearRect(0, 0, width, height);

            const lines = 30;
            const amplitude = 90;
            const frequency = 0.002;
            const speed = 0.0025;

            ctx.lineWidth = 0.8;

            for (let i = 0; i < lines; i++) {
                ctx.beginPath();

                const alpha = 0.1 + (i / lines) * 0.25;
                ctx.strokeStyle = `hsla(217, 54%, 24%, ${alpha})`;

                for (let x = 0; x <= width; x += 30) {
                    const yOffset = height / 1.4;
                    const y1 = Math.sin(x * frequency - time + i * 0.05) * amplitude;
                    const y2 = Math.sin(x * frequency * 0.5 - time * 0.5) * (amplitude * 0.5);
                    const tilt = (x / width) * -150;

                    ctx.lineTo(x, yOffset + y1 + y2 + tilt + (i * 4));
                }

                ctx.stroke();
            }

            time += speed;
            animationFrameId = requestAnimationFrame(draw);
        };

        draw();

        return () => {
            window.removeEventListener("resize", resizeCanvas);
            cancelAnimationFrame(animationFrameId);
        };
    }, []);

    return <canvas ref={canvasRef} className="w-full h-full" />;
};
